import { breakpoints } from "./breakpoint-constants";
var ToggleStickyHeader = /** @class */ (function () {
    function ToggleStickyHeader() {
        this.headerClassName = 'js-header';
        var header = document.getElementsByClassName(this.headerClassName);
        for (var i = 0; i < header.length; i++) {
            new StickyHeader(header[i]);
        }
    }
    return ToggleStickyHeader;
}());
export default ToggleStickyHeader;
var StickyHeader = /** @class */ (function () {
    function StickyHeader(header) {
        this.searchboxContainerClassName = 'js-searchbox-container';
        this.searchboxSummaryClassName = 'js-searchbox-summary';
        this.searchboxCloseButtonClassName = 'js-searchbox-close-button';
        this.searchboxFlyoutClassName = 'js-flyout-searchbox';
        this.headerSearchboxButtonClassName = 'js-header-searchbox-button';
        this.headerPlaceholderClassName = 'js-header-placeholder';
        this.headerTopClassName = 'c-header__top';
        this.offcanvasClassName = 'js-offcanvas-close';
        this.isActiveClass = 'is-active';
        this.searchboxPositionBottom = 0;
        this.headerPlaceholderPositionTop = 0;
        this.headerPositionBottom = 0;
        this.headerStageContentPositionBottom = 0;
        this.headerTopHeight = 0;
        this.resizeTimeout = 0;
        this.stickyClass = '';
        this.header = header;
        this.headerSearchboxButton = header.getElementsByClassName(this.headerSearchboxButtonClassName)[0];
        this.searchboxContainer = header.getElementsByClassName(this.searchboxContainerClassName)[0];
        this.searchboxSummary = header.getElementsByClassName(this.searchboxSummaryClassName)[0];
        this.searchboxCloseButton = header.getElementsByClassName(this.searchboxCloseButtonClassName)[0];
        this.searchboxFlyouts = document.getElementsByClassName(this.searchboxFlyoutClassName);
        this.headerTop = header.getElementsByClassName(this.headerTopClassName)[0];
        this.headerPlaceholder = document.getElementsByClassName(this.headerPlaceholderClassName)[0];
        this.offcanvas = document.getElementsByClassName(this.offcanvasClassName)[0];
        this.setPositions();
        this.stickyClass = this.isIBEHeader() ? 'is-sticky-ibe' : 'is-sticky';
        this.bindEvents();
        this.toggleStickyState();
    }
    StickyHeader.prototype.bindEvents = function () {
        var _this = this;
        var _a;
        window.addEventListener('scroll', function () {
            if (!_this.offcanvas.classList.contains('is-open') || (breakpoints().breakpoints.mobile && !document.body.classList.contains('u-no-body-scroll'))) {
                _this.toggleStickyState();
            }
        });
        window.addEventListener('resize', function () {
            if (!_this.offcanvas.classList.contains('is-open')) {
                _this.onResize();
            }
        });
        (_a = this.headerSearchboxButton) === null || _a === void 0 ? void 0 : _a.addEventListener('click', function () { return window.scrollTo({ top: 0, behavior: 'smooth' }); });
        //this.openSearchboxContainer();
        //this.closeSearchboxContainer();
    };
    StickyHeader.prototype.getHeadlinePlaceholderPositionTop = function () {
        return this.headerPlaceholder ? this.headerPlaceholder.offsetTop : 0;
    };
    StickyHeader.prototype.scrollTop = function () {
        return typeof window.scrollY === 'undefined' ? window.pageYOffset : window.scrollY;
    };
    StickyHeader.prototype.isIBEHeader = function () {
        return this.header.classList.contains('js-header-ibe');
    };
    StickyHeader.prototype.isHomeHeader = function () {
        return this.header.classList.contains('js-header-home');
    };
    StickyHeader.prototype.isSearchboxCloseButton = function () {
        return this.searchboxCloseButton;
    };
    StickyHeader.prototype.setPositions = function () {
        this.headerPositionBottom = this.header.getBoundingClientRect().height;
        this.headerPlaceholderPositionTop = this.getHeadlinePlaceholderPositionTop();
        this.headerTopHeight = this.headerTop ? this.headerTop.getBoundingClientRect().height : 0;
        if (this.scrollTop() === 0) {
            this.searchboxPositionBottom = this.searchboxContainer.getBoundingClientRect().bottom;
        }
        else {
            this.searchboxPositionBottom = this.searchboxContainer.getBoundingClientRect().bottom + this.scrollTop();
        }
    };
    StickyHeader.prototype.onResize = function () {
        var _this = this;
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(function () {
            _this.setPositions();
            _this.toggleStickyState();
        }, 350);
    };
    StickyHeader.prototype.toggleStatePosition = function () {
        var positionTop = 0;
        if (this.isIBEHeader()) {
            positionTop = this.headerTopHeight;
        }
        else if (this.isHomeHeader()) {
            positionTop = this.searchboxPositionBottom > 0 ? this.searchboxPositionBottom : this.headerPositionBottom;
        }
        else {
            positionTop = this.headerPositionBottom - this.headerTopHeight;
        }
        return positionTop;
    };
    StickyHeader.prototype.isSticky = function (stickyClass) {
        return stickyClass ? this.header.classList.contains(stickyClass) : false;
    };
    StickyHeader.prototype.addStickyState = function (stickyClass) {
        if (this.header.classList.contains('c-header--content')) {
            this.header.style.height = this.header.offsetHeight + 'px';
        }
        this.header.classList.add(stickyClass);
        if (!breakpoints().breakpoints.mobile) {
            for (var i = 0; i < this.searchboxFlyouts.length; i++) {
                this.searchboxFlyouts[i].classList.add(this.stickyClass);
            }
        }
    };
    StickyHeader.prototype.removeStickyState = function (stickyClass) {
        var _this = this;
        if (this.header.classList.contains('c-header--content')) {
            setTimeout(function () {
                _this.header.style.height = 'auto';
            }, 500);
        }
        this.header.classList.remove(stickyClass);
        if (!breakpoints().breakpoints.mobile) {
            for (var i = 0; i < this.searchboxFlyouts.length; i++) {
                this.searchboxFlyouts[i].classList.remove(this.stickyClass);
            }
        }
    };
    StickyHeader.prototype.toggleStickyState = function () {
        if (this.scrollTop() > this.toggleStatePosition() && !this.isSticky(this.stickyClass)) {
            this.addStickyState(this.stickyClass);
        }
        else if (this.scrollTop() <= this.toggleStatePosition() && this.isSticky(this.stickyClass)) {
            this.removeStickyState(this.stickyClass);
        }
    };
    StickyHeader.prototype.searchboxTriggerElement = function () {
        if (typeof (this.headerSearchboxButton) != 'undefined') {
            return this.headerSearchboxButton;
        }
        else {
            return this.searchboxSummary;
        }
    };
    StickyHeader.prototype.openSearchboxContainer = function () {
        var _this = this;
        this.searchboxTriggerElement().addEventListener("click", function () {
            _this.searchboxContainer.classList.add('is-active');
            _this.header.classList.add('has-searchbox');
        });
    };
    StickyHeader.prototype.closeSearchboxContainer = function () {
        var _this = this;
        if (this.isSearchboxCloseButton()) {
            this.searchboxCloseButton.addEventListener("click", function () {
                _this.searchboxContainer.classList.remove('is-active');
                _this.header.classList.remove('has-searchbox');
            });
        }
    };
    return StickyHeader;
}());
